export enum Roles {
  Admin = 'Admin',
  HR_Delegate = 'HR Delegate',
  Manager = 'Manager',
  Employee = 'Employee',
}
